export default "__VITE_ASSET__CvRJYOzI__"